import api from './api';

// Admin panel uses email + password. The mobile OTP endpoints (/auth/*)
// belong to the mobile app.
const authService = {
  login: async (email, password) => {
    const response = await api.post('/admin/auth/login', { email, password });
    return response.data;
  },

  forgotPassword: async (email) => {
    const response = await api.post('/admin/auth/forgot-password', { email });
    return response.data;
  },

  resetPassword: async (email, otp, newPassword) => {
    const response = await api.post('/admin/auth/reset-password', { email, otp, newPassword });
    return response.data;
  },

  changePassword: async (currentPassword, newPassword) => {
    const response = await api.post('/admin/auth/change-password', { currentPassword, newPassword });
    return response.data;
  },

  sendChangeMobileOtp: async (currentPassword, newMobile) => {
    const response = await api.post('/admin/auth/change-mobile/send-otp', { currentPassword, newMobile });
    return response.data;
  },

  verifyChangeMobile: async (otp) => {
    const response = await api.post('/admin/auth/change-mobile/verify', { otp });
    return response.data;
  },

  logout: async () => {
    const response = await api.post('/auth/logout');
    return response.data;
  },
};

export default authService;
